import * as React from 'react'
import { Link } from 'react-router'
import { IMultiLocationInventory } from '@getgreenline/homi-shared'
import { InventoryDisplay } from './InventoryDisplay'
import { Routes } from '../../../../../constants/Routes'
import { SmartImage } from '../../../../../components/SmartImage'
import './InventoryRow.scss'

interface Props {
  companyId: number
  hasEditProductPermissions: boolean
  multiLocationInventory: IMultiLocationInventory
  locationIdFilter?: number
  onUpdate: () => void
  showCategory: boolean
  showBrand: boolean
  showLowStockQuantity: boolean
}

export class ViewInventoryRow extends React.Component<Props, {}> {
  render() {
    const { multiLocationInventory, showLowStockQuantity } = this.props
    const product = multiLocationInventory.product
    let inventories = multiLocationInventory.inventories

    if (this.props.locationIdFilter) {
      inventories = inventories.filter(
        (inventory) => inventory.locationId === this.props.locationIdFilter,
      )
    }

    return (
      <tr>
        <td style={{ width: 70 }}>
          {!!product.imageUrl && (
            <SmartImage className='img-thumbnail' src={product.imageUrl} width={50} height={50} />
          )}
        </td>

        <td style={{ minWidth: 200, maxWidth: 250 }}>
          <div>
            {this.props.hasEditProductPermissions ? (
              <Link
                target='_blank'
                to={Routes.EDIT_PRODUCT(
                  this.props.companyId,
                  product.parentProductId || product.id,
                )}
              >
                <span className='mr-2'>{product.parentProductName || product.name}</span>
              </Link>
            ) : (
              <span className='mr-2'>{product.parentProductName || product.name}</span>
            )}
            {product.parentProductName ? <div>{product.name}</div> : undefined}
          </div>
        </td>
        {<td className='text-muted'>{product.sku || '-'}</td>}

        {this.props.showCategory && (
          <td className='text-muted'>
            {product.parentCategoryName && product.categoryName !== product.parentCategoryName && (
              <div>{product.parentCategoryName}</div>
            )}
            {product.categoryName || '-'}
          </td>
        )}

        {this.props.showBrand && <td className='text-muted'>{product.supplierName || '-'}</td>}

        {inventories.map((inventory, index) => {
          return (
            <InventoryDisplay
              key={index}
              locationId={inventory.locationId}
              product={product}
              quantity={inventory.quantity}
              lowStockQuantity={inventory.lowStockQuantity}
              restockQuantity={inventory.restockQuantity}
              showLowStockQuantity={showLowStockQuantity}
              onUpdate={() => this.props.onUpdate()}
            />
          )
        })}
      </tr>
    )
  }
}
